import React from 'react';
import { cn } from '@/lib/core/utils';
import { Button } from '@/components/ui/button';
import { Users, Clock } from 'lucide-react';

export type KioskMode = 'customer' | 'staff';

interface KioskModeSelectorProps {
  mode: KioskMode;
  onModeChange: (mode: KioskMode) => void;
  className?: string;
}

/**
 * Mode selector tabs for switching between Customer and Staff modes
 */
export function KioskModeSelector({ mode, onModeChange, className }: KioskModeSelectorProps) {
  return (
    <div className={cn('flex justify-center gap-2 p-4 bg-white dark:bg-card border-b border-gray-200 dark:border-border', className)}>
      <Button
        onClick={() => onModeChange('customer')}
        variant={mode === 'customer' ? 'default' : 'outline'}
        size="lg"
        className={cn(
          'min-w-[180px] h-14 text-lg font-medium gap-3',
          mode === 'customer' && 'bg-primary text-white'
        )}
      >
        <Users className="w-5 h-5" />
        Customer
      </Button>

      <Button
        onClick={() => onModeChange('staff')}
        variant={mode === 'staff' ? 'default' : 'outline'}
        size="lg"
        className={cn(
          'min-w-[180px] h-14 text-lg font-medium gap-3',
          mode === 'staff' && 'bg-green-600 hover:bg-green-700 text-white'
        )}
      >
        <Clock className="w-5 h-5" />
        Staff
      </Button>
    </div>
  );
}
